var _style, _ellipse, _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgO(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.1;}\n\t.st1{fill:#E94364;stroke:#5F5C74;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#E30613;stroke:#FFFFFF;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#FFFFFF;}\n")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 125,
    cy: 227.8,
    rx: 112.5,
    ry: 19.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206,148.9c0,45.9-37.2,78.9-83,78.9s-83-33-83-78.9C40,72.1,123,7.8,123,7.8S206,72.1,206,148.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st1",
    d: "M234.2,77c0,20.5-16.6,35.3-37.2,35.3c-20.5,0-37.2-14.8-37.2-35.3c0-34.4,37.2-63.2,37.2-63.2 S234.2,42.6,234.2,77z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("line", {
    id: "XMLID_2_",
    className: "st2",
    x1: 185.4,
    y1: 73.2,
    x2: 208.7,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1_",
    className: "st2",
    x1: 197,
    y1: 61.6,
    x2: 197,
    y2: 84.8
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st3",
    d: "M127,108.2c4.5,0,8.3,0.9,11.5,2.7c3.2,1.8,5.6,4.4,7.3,7.7c1.6,3.3,2.5,7.2,2.5,11.7 c0,3.3-0.4,6.3-1.3,9.1s-2.2,5.1-4,7.1s-4,3.5-6.6,4.6s-5.6,1.6-9,1.6c-3.4,0-6.4-0.5-9-1.6c-2.7-1.1-4.9-2.6-6.7-4.6 c-1.8-2-3.1-4.3-4-7.1s-1.4-5.8-1.4-9c0-3.3,0.5-6.3,1.4-9.1c0.9-2.8,2.3-5.1,4.1-7c1.8-1.9,4-3.4,6.6-4.4S123.7,108.2,127,108.2z  M139.4,130.2c0-3.1-0.5-5.9-1.5-8.2c-1-2.3-2.5-4-4.4-5.2c-1.9-1.2-4-1.8-6.5-1.8c-1.7,0-3.3,0.3-4.8,1c-1.5,0.7-2.7,1.6-3.8,2.9 c-1.1,1.3-1.9,2.8-2.5,4.8c-0.6,1.9-0.9,4.1-0.9,6.5c0,2.4,0.3,4.6,0.9,6.6s1.5,3.6,2.6,4.9c1.1,1.3,2.4,2.3,3.9,2.9 c1.5,0.6,3.1,1,4.8,1c2.2,0,4.3-0.6,6.1-1.7s3.3-2.8,4.5-5.2S139.4,133.6,139.4,130.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgO);
export default __webpack_public_path__ + "static/media/o+.ce4de10692f65506c83db5a2836558fb.svg";
export { ForwardRef as ReactComponent };